<template>
  <lazy-component>
    <div class="video-wrapper">
      <iframe
        class="video-iframe"
        width="100%"
        height="100%"
        :src="src"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: "app-giphy",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    src() {
      return `https://giphy.com/embed/${this.id}`;
    }
  }
};
</script>

<style scoped lang="scss">
.video-wrapper {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  .video-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
